export const mapValueLengthToFontSize = (lenght: number) => {
  if (lenght >= 17) {
    return 12;
  }
  switch (lenght) {
    case 16:
      return 13;
    case 15:
      return 14;
    case 14:
      return 15;
    case 13:
      return 16;
    case 12:
      return 18;
    case 11:
      return 20;
    case 10:
      return 22;
    default:
      return 24;
  }
};

export const mapValueLengthToLineHeight = (lenght: number) => {
  if (lenght >= 17) {
    return 18;
  }
  switch (lenght) {
    case 16:
      return 20;
    case 15:
      return 20;
    case 14:
      return 20;
    case 13:
      return 20;
    case 12:
      return 24;
    case 11:
      return 24;
    case 10:
      return 26;
    default:
      return 31;
  }
};
